import { createStructuredSelector } from 'reselect'

import {
  AMBULANCE_LIST,
  AMBULANCE_LIST_SUCCESS,
  AMBULANCE_LIST_ERROR,
  AMBULANCE_PAGE_SET,
  AMBULANCE_SEARCH_SET,
  AMBULANCE_SEARCH_CHANGE,
  AMBULANCE_DETAIL,
  AMBULANCE_DETAIL_SUCCESS,
  AMBULANCE_DETAIL_ERROR,
  AMBULANCE_VIEW_MODAL_SET,
  AMBULANCE_MAINTENANCE_UPDATE,
  AMBULANCE_MAINTENANCE_UPDATE_SUCCESS,
  AMBULANCE_MAINTENANCE_UPDATE_ERROR,
  AMBULANCE_ADD_MODAL_SET,
  AMBULANCE_ADD_CHANGE
} from '../actions';

export const AMBULANCE_NAME = 'ambulance';
const NAME = AMBULANCE_NAME;

export const AmbulanceList = (page, num_page, filters) => ({
  type: AMBULANCE_LIST,
  payload: { page: page, num_page: num_page, filters: filters }
});

export const AmbulanceListSuccess = (data) => ({
  type: AMBULANCE_LIST_SUCCESS,
  payload: data
});

export const AmbulanceListError = (error) => ({
  type: AMBULANCE_LIST_ERROR,
  payload: error
});

export const AmbulancePageSet = (data) => ({
  type: AMBULANCE_PAGE_SET,
  payload: data
});

export const AmbulanceSearchSet = (data) => ({
  type: AMBULANCE_SEARCH_SET,
  payload: data
});

export const AmbulanceSearchChangeSet = (data) => ({
  type: AMBULANCE_SEARCH_CHANGE,
  payload: data
});

export const AmbulanceDetail = (data) => ({
  type: AMBULANCE_DETAIL,
  payload: data
});

export const AmbulanceDetailSuccess = (data) => ({
  type: AMBULANCE_DETAIL_SUCCESS,
  payload: data
});

export const AmbulanceDetailError = (error) => ({
  type: AMBULANCE_DETAIL_ERROR,
  payload: error
});

export const AmbulanceViewModalSet = (data) => ({
  type: AMBULANCE_VIEW_MODAL_SET,
  payload: data
});

export const AmbulanceMaintenanceUpdate = (data) => ({
  type: AMBULANCE_MAINTENANCE_UPDATE,
  payload: data
});

export const AmbulanceMaintenanceUpdateSuccess = (data) => ({
  type: AMBULANCE_MAINTENANCE_UPDATE_SUCCESS,
  payload: data
});

export const AmbulanceMaintenanceUpdateError = (error) => ({
  type: AMBULANCE_MAINTENANCE_UPDATE_ERROR,
  payload: error
});

export const AmbulanceAddModalSet = (data) => ({
  type: AMBULANCE_ADD_MODAL_SET,
  payload: data
});

export const AmbulanceAddChangeSet = (data) => ({
  type: AMBULANCE_ADD_CHANGE,
  payload: data
});

const ambulance = (state) => state[NAME];

export const AmbulanceSelector = createStructuredSelector({
  ambulance
});
